import { Component, model, OnDestroy, signal } from '@angular/core';

const tickMs = 150;
const ceiling = 92;
const startupMs = 700;
const perItemMs = 45;
const minDurationMs = 1500;
const maxDurationMs = 120000;

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true
})
export class LoaderComponent implements OnDestroy {
  loading = model<boolean>(false);
  progress = signal<number | null>(null);

  protected readonly dots: number[] = [0, 1, 2];

  private timer: ReturnType<typeof setInterval> = null;
  private startedAt = 0;
  private durationMs = 0;

  show(itemCount = 0): void {
    this.stopTimer();
    this.progress.set(null);
    this.loading.set(true);

    if (itemCount > 1) {
      this.durationMs = Math.min(maxDurationMs, Math.max(minDurationMs, startupMs + perItemMs * itemCount));
      this.startedAt = Date.now();
      this.progress.set(0);
      this.timer = setInterval(() => this.tick(), tickMs);
    }
  }

  hide(): void {
    this.stopTimer();
    this.loading.set(false);
    this.progress.set(null);
  }

  setProgress(percent: number | null): void {
    this.stopTimer();

    if (percent === null || percent === undefined || isNaN(percent)) {
      this.progress.set(null);
      return;
    }

    this.progress.set(Math.max(0, Math.min(100, Math.round(percent))));
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  private tick(): void {
    const next: number = Math.round(ceiling * (1 - Math.exp((-3 * (Date.now() - this.startedAt)) / this.durationMs)));
    this.progress.update(current => (next > current ? next : current));

    if (next >= ceiling) {
      this.stopTimer();
    }
  }

  private stopTimer(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
